import { useQuery } from '@tanstack/react-query';
import { Endpoints } from '@xver/apis';
import { useActiveProjectScope } from '@xver/hooks/useActiveProject';
import type { ListDomainMappingsResponse } from '@xver/apis/v1/kufer/domain-mappings/model';

export const DOMAIN_MAPPINGS_QUERY_KEY = 'apis.v1.kufer.domain-mappings.list';

export function useDomainMappingsQuery(containerId: string | undefined) {
    const { isResolved } = useActiveProjectScope();
    return useQuery<ListDomainMappingsResponse>({
        queryKey: [DOMAIN_MAPPINGS_QUERY_KEY, containerId],
        queryFn: () => Endpoints.v1.Kufer.DomainMappings.listDomainMappings(containerId as string),
        refetchInterval: 10000,
        enabled: !!containerId && isResolved,
    });
}
